import React from "react";
import { Box, Link, VStack, IconButton, useColorMode } from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { Link as RouterLink } from "react-router-dom";
import { motion } from "framer-motion";

const Header = () => {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Box
      p={4}
      bgColor="blackAlpha.900"
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      boxShadow="md"
    >
      <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
        <Link
          as={RouterLink}
          to="/"
          color="white"
          fontSize="2xl"
          fontWeight="bold"
        >
          Nobto
        </Link>
      </motion.div>
      <VStack spacing={2} ml={-4}>
        <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <Link
            as={RouterLink}
            to="/exchanges"
            color="white"
            _hover={{ textDecoration: "none", color: "cyan.400" }}
          >
            Exchanges
          </Link>
        </motion.div>
        <motion.div whileHover={{ scale: 1.05 }} transition={{ duration: 0.3 }}>
          <Link
            as={RouterLink}
            to="/coins"
            color="white"
            _hover={{ textDecoration: "none", color: "cyan.400" }}
          >
            Coins
          </Link>
        </motion.div>
      </VStack>
      <motion.div
        whileHover={{ scale: 1.1, rotate: 45 }}
        transition={{ duration: 0.3 }}
      >
        <IconButton
          aria-label="Toggle Color Mode"
          icon={colorMode === "light" ? <MoonIcon /> : <SunIcon />}
          variant="unstyled"
          onClick={toggleColorMode}
          color="white"
          _hover={{ textDecoration: "none" }}
        />
      </motion.div>
    </Box>
  );
};

export default Header;
